<template>
  <div id="app">
    <Header />
    <Home msg="Welcome to Copy of ListDiff an App to work with email lists"/>
  </div>
</template>

<script>
import Header from './components/Header'
import Home from './components/Home'
// import Footer from './components/Footer'
export default {
  name: 'app',
  components: {
    Header,
    Home,
    // Footer
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 0px;
}
</style>
